import './container/PageContainer.scss';

import classNames from 'classnames';
import { useLayoutEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router';

import { AnnouncementBanners } from '@components/AnnouncementBanner/AnnouncementBanner';
import Footer from '@components/Footer/Footer';
import Header from '@components/Header/HeaderNav';
import { ROUTES } from '@constants/routes';
import useApp from '@hooks/useApp';

// Routes whose design calls for one continuous white surface from nav to footer.
// It has to live here because the announcement banners are a sibling of Outlet,
// so a page cannot paint behind them from inside its own containers.
const WHITE_SURFACE_ROUTES: string[] = [ROUTES.HOME];

const MainLayout = () => {
  const pageContainerRef = useRef<HTMLDivElement>(null);
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  const { isLoggedIn } = useApp();

  // Reset every possible scroll target. `.page-container` is the primary scroller
  // on desktop; below 1020px `main` can hold scroll independently, and `.App`
  // unlocks so the document itself may scroll.
  useLayoutEffect(() => {
    pageContainerRef.current?.scrollTo(0, 0);
    mainRef.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div ref={pageContainerRef} className='page-container' data-testid='pageContainer'>
      <Header />
      <main
        ref={mainRef}
        className={classNames('w-100 page-main', WHITE_SURFACE_ROUTES.includes(pathname) && 'page-main--white')}
        data-testid='pageMain'
      >
        {isLoggedIn && <AnnouncementBanners />}
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
